import {
  Box,
  Center, Flex, Heading, SimpleGrid,
  Stack,
  Text
} from '@chakra-ui/react';
import { FormStep } from '../MultiStepForm';
import RadioField from '../RadioField';
import * as yup from 'yup';

export default function Roles(props:{onSubmit:any, formError:any, validationSchema:any}) {
  const { onSubmit, formError, validationSchema } = props;
  return(<FormStep stepName="roles" onSubmit={onSubmit} formError={formError} validationSchema={validationSchema}>
  <Center>
      <Stack>
          <Box w="788px" h="28rem">
              <Heading
                  fontSize="32px"
                  fontWeight={800}
                  width="800px"
                  display="flex"
                  justifyContent="center"
              >
                  What kind of roles are you looking for?
              </Heading>
              <Text
                  fontWeight={500}
                  lineHeight="20px"
                  fontSize="18px"
                  align="center"
                  mt="28px"
                  mb="12px"
              >
                  What type of roles?
              </Text>
              <Box>
                  <SimpleGrid
                      columns={3}
                      spacingX="8px"
                      spacingY={3}
                      h="100px"
                      alignSelf="center"
                  >
                      <RadioField
                          name="roles"
                          align="center"
                          type="radiobutton"
                          value="Jobs"
                          text="Jobs"
                          topMargin="2px"
                          width="240px"
                          height="48px"
                      />
                      <RadioField
                          name="roles"
                          align="center"
                          type="radiobutton"
                          value="Internships"
                          text="Internships"
                          topMargin="2px"
                          width="240px"
                          height="48px"
                      />
                      <RadioField
                          name="roles"
                          align="center"
                          type="radiobutton"
                          value="Both"
                          text="Both"
                          topMargin="2px"
                          width="240px"
                          height="48px"
                      />
                  </SimpleGrid>
              </Box>
              <Text
                  fontWeight={500}
                  lineHeight="20px"
                  fontSize="18px"
                  align="center"
                  mb="12px"
              >
                  What time commitment?
              </Text>
              <Box>
                  <SimpleGrid
                      columns={3}
                      spacingX="8px"
                      spacingY={3}
                      h="100px"
                      alignSelf="center"
                  >
                      <RadioField
                          name="time-commitment"
                          align="center"
                          type="radiobutton"
                          value="Full-Time"
                          text="Full-Time"
                          topMargin="2px"
                          width="240px"
                          height="48px"
                      />
                      <RadioField
                          name="time-commitment"
                          align="center"
                          type="radiobutton"
                          value="Part-Time"
                          text="Part-Time"
                          topMargin="2px"
                          width="240px"
                          height="48px"
                      />
                      <RadioField
                          name="time-commitment"
                          align="center"
                          type="radiobutton"
                          value="Both"
                          text="Both"
                          topMargin="2px"
                          width="240px"
                          height="48px"
                      />
                  </SimpleGrid>
              </Box>
              <Text
                  fontWeight={500}
                  lineHeight="20px"
                  fontSize="18px"
                  align="center"
                  mb="12px"
              >
                  When can you start?
              </Text>
              <Center>
                  <Flex gap="8px" alignItems="center" w="788px">
                      <RadioField
                          name="start-date"
                          align="center"
                          width="full"
                          type="radiobutton"
                          value="ASAP"
                          text="ASAP"
                      />
                      <RadioField
                          name="start-date"
                          align="center"
                          width="full"
                          type="radiobutton"
                          value="Winter 2023"
                          text="Winter 2023"
                      />
                      <RadioField
                          name="start-date"
                          align="center"
                          width="full"
                          type="radiobutton"
                          value="Spring 2023"
                          text="Spring 2023"
                      />
                      <RadioField
                          name="start-date"
                          align="center"
                          width="full"
                          type="radiobutton"
                          value="Summer 2023"
                          text="Summer 2023"
                      />
                      <RadioField
                          name="start-date"
                          align="center"
                          width="full"
                          type="radiobutton"
                          value="Fall 2023"
                          text="Fall 2023"
                      />
                  </Flex>
              </Center>
          </Box>
      </Stack>
  </Center>
</FormStep>);
}